import { render, staticRenderFns } from "./TodayMatches.vue?vue&type=template&id=10ed139c&scoped=true"
import script from "./TodayMatches.vue?vue&type=script&lang=js"
export * from "./TodayMatches.vue?vue&type=script&lang=js"
import style0 from "./TodayMatches.vue?vue&type=style&index=0&id=10ed139c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ed139c",
  null
  
)

export default component.exports